import { STATUS_TYPE } from '../../../enum';

export interface GetColor {
  id: string;
}

export interface FindColor {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchColor {
  id?: string;
  colorCode: string;
  labelEn: string;
  labelAr: string;
  // colorType: string;
  position: string;
  activeState: boolean;
}

export interface Color {
  id: string;
  colorCode: string;
  labelEn: string;
  labelAr: string;
  // colorType: string;
  position: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: Color[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
